// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1cso3","label":"styles_label__3qZrA"};